import { ReactComponentElement } from "react";
import styles from "./RadioControlOption.module.scss";

export interface RadioControlOptionProps {
  icon?: ReactComponentElement<"svg">;
  name: string;
  value: string;
}

const RadioControlOption = ({ icon, name }: RadioControlOptionProps) => {
  return (
    <button className={styles.root}>
      {icon}
      <span>{name}</span>
    </button>
  );
};

export default RadioControlOption;
